import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import AudienceGrid from "./AudienceGrid";
import { useSheets } from "../../../hooks/useSheets";

const AudienceModal = ({ open, onClose, audience_id, updateData }) => {
  const theme = useTheme();

  const { rows, loading, error, refetch } = useSheets();

  const [selectionModel, setSelectionModel] = useState([]);

  const selectedRow = rows.find((r) => r.id === selectionModel[0]);

  useEffect(() => {
    if (open && audience_id) {
      setSelectionModel([audience_id]);
      return;
    }

    if (!open) {
      setSelectionModel([]);
    }
  }, [open, audience_id]);

  const handleSelect = () => {
    if (!selectedRow) return;

    updateData({
      audience_id: selectedRow.id,
      audience: selectedRow,
    });

    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "96vw", sm: "90vw", md: "80vw" },
          height: { xs: "96vh", sm: "90vh" },
          backgroundColor: "#F7F7FC",
          borderRadius: 2,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <Box
          px={3}
          py={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography sx={{ fontSize: 24, fontWeight: 500, color: "#545454" }}>
            Selecione uma listagem
          </Typography>

          <CloseOutlined
            onClick={onClose}
            sx={{ cursor: "pointer", color: theme.palette.custom.gray[300] }}
          />
        </Box>

        {/* BODY */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,  
            overflow: "auto",

            "&::-webkit-scrollbar": {
              width: 10,
              height: 10,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#C7C7CC",
              borderRadius: 10,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },

            scrollbarWidth: "thin",
            scrollbarColor: "#C7C7CC transparent",
          }}
        >
          {error ? (
            <Box sx={{ p: 2 }}>
              <Typography color="error" fontSize={13} mb={2}>
                Erro ao carregar listagens.
              </Typography>

              <Button variant="contained" onClick={refetch}>
                Tentar novamente
              </Button>
            </Box>
          ) : (
            <AudienceGrid
              rows={rows}
              loading={loading}
              selectionModel={selectionModel}
              onSelectionChange={setSelectionModel}
            />
          )}
        </Box>

        {/* FOOTER */}
        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="flex-end"
          gap={2}
          borderTop="1px solid #E5E5EF"
          bgcolor="#F7F7FC"
        >
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={!selectedRow}
            onClick={handleSelect}
          >
            Selecionar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AudienceModal;
